/**
 * DaKasa's own CNPJ. Payments recognises the house company by these same
 * digits (Payments ADR 0001), and no service carries an org flag for it.
 */
export const DAKASA_CNPJ = "53411564000183";

/**
 * True only for DaKasa's own CNPJ, masked ("53.411.564/0001-83") or not.
 * Enterprise serialises the CNPJ from a bigint, so leading zeros may be
 * missing and the value may arrive as a number. Anything else, a missing
 * value included, is false: callers fail closed.
 */
export function isDaKasaCnpj(value: unknown): boolean {
  if (typeof value !== "string" && typeof value !== "number") return false;
  const digits = String(value).replace(/\D/g, "");
  return digits.length > 0 && digits.length <= 14 && digits.padStart(14, "0") === DAKASA_CNPJ;
}
